import * as LabelPrimitive from "radix-ui/label";
import type { ComponentProps } from "react";
import { cn } from "./cn";

export function Label({ className, ...props }: ComponentProps<typeof LabelPrimitive.Root>) {
  return (
    <LabelPrimitive.Root
      className={cn("text-cell font-medium text-fg peer-disabled:opacity-50", className)}
      {...props}
    />
  );
}
